import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import DatePicker from './DatePicker'
import { observer } from 'mobx-react'

const DatePickerRange = props => {
  const {
    onFromChange,
    onToChange,
    month,
    fromDate,
    toDate,
    maxDate,
    fromError,
    toError,
    dateOnly,
    disabled
  } = props

  let fromMaxDate = dateOnly ? moment(toDate).toDate() : toDate;
  if (fromMaxDate === null) {
    fromMaxDate = maxDate;
  }

  return (
    <div className='datepicker__range'>
      <DatePicker
        month={month}
        onChange={onFromChange}
        maxDate={fromMaxDate}
        date={fromDate}
        error={fromError}
        dateOnly={dateOnly}
        disabled={disabled}
      />
      <span className='datepicker__separator'>—</span>
      <DatePicker
        month={month}
        onChange={onToChange}
        minDate={dateOnly ? moment(fromDate).toDate() : fromDate}
        maxDate={maxDate}
        date={toDate}
        error={toError}
        dateOnly={dateOnly}
        disabled={disabled}
      />
    </div>
  )
}

DatePickerRange.propTypes = {
  month: PropTypes.bool,
  onFromChange: PropTypes.func.isRequired,
  onToChange: PropTypes.func.isRequired,
  fromDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  toDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  dateOnly: PropTypes.bool,
  toError: PropTypes.string,
  fromError: PropTypes.string,
  disabled: PropTypes.bool
}

export { DatePickerRange }
export default observer(DatePickerRange)
